import {
  Intl,
  PushNotificationRegistrar,
  PushNotificationRegistrationUI,
  PushNotificationEventPublishers,
  NotificationSettingsAuthority,
  BootstrapWidgets,
  FormEvents,
  EventStream
} from 'Roblox';
import accountSettingsModule from '../accountSettingsModule';

function accountsContentController(
  $scope,
  $window,
  $log,
  $filter,
  accountsService,
  $timeout,
  $interval,
  $document,
  $location,
  $state,
  $uibModal,
  modalService,
  notificationConstantsService,
  modalConstantsService,
  accountConstantsResources,
  commonConstantsService,
  languageResource,
  systemFeedbackService,
  $q,
  premiumService,
  eventTrackerService
) {
  'ngInject';

  const customText = 'Custom';
  const defaultText = 'Default';
  const offText = 'Off';
  const allUsersText = 'AllUsers';
  const friendsText = 'Friends';
  const noOneText = 'NoOne';
  let initialModalsLoaded = false;
  const intl = Intl && new Intl();

  const socialNetworkErrorMessage = commonConstantsService.validation.invalid.socialMedia;

  const _desktopPushRegistration = (function() {
    let isEnabledCachedResult = false;
    let isEnabledLookupStarted = false;
    let isEnabledLookupFinished = false;

    const startIsEnabledLookup = function(callback) {
      isEnabledLookupFinished = false;
      isEnabledCachedResult = false;
      isEnabledLookupStarted = true;
      if (PushNotificationRegistrar) {
        PushNotificationRegistrar.isPushEnabled(function(isEnabled) {
          isEnabledLookupStarted = false;
          isEnabledLookupFinished = true;
          isEnabledCachedResult = isEnabled;
          $timeout(function() {});
          callback(true);
        });
      }
    };

    const clearIsEnabledCache = function() {
      isEnabledLookupFinished = false;
      isEnabledCachedResult = false;
    };

    const isAvailable = function() {
      return (
        PushNotificationRegistrar &&
        PushNotificationRegistrar.isPushSupported() &&
        PushNotificationRegistrationUI
      );
    };

    const isEnabled = function(callback) {
      if (!isAvailable()) {
        return false;
      }

      if (isEnabledLookupFinished) {
        return isEnabledCachedResult;
      }
      if (!isEnabledLookupStarted) {
        startIsEnabledLookup(callback);
      }
      return false;
    };

    const enable = function(callback) {
      if (!isAvailable()) {
        return;
      }
      PushNotificationRegistrationUI.enable(function() {
        PushNotificationRegistrar.getEventPublisher().Publish(
          PushNotificationEventPublishers.RegistrationEventTypes.settingsPageEnabled
        );
        clearIsEnabledCache();
        callback();
      });
    };

    const disable = function(callback) {
      if (!isAvailable()) {
        return;
      }
      PushNotificationRegistrationUI.disable(function() {
        PushNotificationRegistrar.getEventPublisher().Publish(
          PushNotificationEventPublishers.RegistrationEventTypes.settingsPageDisabled
        );
        clearIsEnabledCache();
        callback();
      });
    };

    const isToggleable = function() {
      return true;
    };

    return {
      isAvailable,
      isEnabled,
      enable,
      disable,
      isToggleable
    };
  })();

  const _mobilePushRegistration = (function() {
    let isEnabledCachedResult = false;
    let isEnabledLookupStarted = false;
    let isEnabledLookupFinished = false;

    const startIsEnabledLookup = function(callback) {
      isEnabledLookupFinished = false;
      isEnabledCachedResult = false;
      isEnabledLookupStarted = true;
      NotificationSettingsAuthority.isPushEnabled(function(isEnabled) {
        isEnabledLookupStarted = false;
        isEnabledLookupFinished = true;
        isEnabledCachedResult = isEnabled;
        $timeout(function() {});
        callback(true);
      });
    };

    const clearIsEnabledCache = function() {
      isEnabledLookupFinished = false;
      isEnabledCachedResult = false;
    };

    const isEnabled = function(callback) {
      if (isEnabledLookupFinished) {
        return isEnabledCachedResult;
      }
      if (!isEnabledLookupStarted) {
        startIsEnabledLookup(callback);
      }
      return false;
    };

    const isAvailable = function() {
      return true;
    };

    const isToggleable = function() {
      return NotificationSettingsAuthority.canToggleMobilePushNotifications();
    };

    const enable = function(callback) {
      $document.triggerHandler('Roblox.Settings.PushEnabledOnDevice');
      isEnabledCachedResult = true;
    };

    const disable = function(callback) {
      NotificationSettingsAuthority.deregisterCurrentDevice(function() {
        clearIsEnabledCache();
        callback(true);
      });
    };

    return {
      isAvailable,
      isToggleable,
      enable,
      disable,
      isEnabled
    };
  })();

  function displayInitialModals() {
    if (initialModalsLoaded) {
      return;
    }
    initialModalsLoaded = true;

    const search = $location.search();
    if (search.changepassword) {
      $scope.setPassword();
    } else if (search.confirmemail) {
      const message =
        modalConstants.emailVerify[
          search.confirmemail + modalConstants.emailVerify.messageSuffix
        ] || modalConstants.emailVerify.unspecifiedMessage;
      const action =
        modalConstants.emailVerify[search.confirmemail + modalConstants.emailVerify.actionSuffix] ||
        '';
      $scope.confirmEmail(message, action);
    }
  }

  // Limit here is for testing, user will most likely be hit by floodchecker before hitting this limit
  const retryPinUnlockLimit = 100;
  const _notificationSourceTypeMapping = notificationConstantsService.notificationSourceTypeMapping;
  const _receiverDestinationTypeMapping =
    notificationConstantsService.receiverDestinationTypeMapping;

  _receiverDestinationTypeMapping.forEach(function(item) {
    if (item.destinationType === 'DesktopPush') {
      item.getUnavailableReason = function() {
        const chromeMessage = `Google Chrome versions ${$scope.desktopPushSettings.minimumChromeVersion} and above`;
        const firefoxMessage = $scope.desktopPushSettings.enabledOnFirefox
          ? ', and Firefox versions 46 and above'
          : '';
        return `Desktop Push is currently only supported on ${chromeMessage}${firefoxMessage}.`;
      };
      item.areSourcesShown = true;
      item.availabilityCheck = _desktopPushRegistration.isAvailable;
      item.customEnablement = _desktopPushRegistration.enable;
      item.customDisablement = _desktopPushRegistration.disable;
      item.customEnabledCheck = _desktopPushRegistration.isEnabled;
      item.isToggleable = _desktopPushRegistration.isToggleable;
    }

    if (item.destinationType === 'MobilePush') {
      item.availabilityCheck = _mobilePushRegistration.isAvailable;
      item.customEnablement = _mobilePushRegistration.enable;
      item.customDisablement = _mobilePushRegistration.disable;
      item.customEnabledCheck = _mobilePushRegistration.isEnabled;
      item.isToggleable = _mobilePushRegistration.isToggleable;
    }
  });

  function setUserSubscriptionInfo() {
    if ($scope.accountContent.userInfo.data) {
      const userInfoData = $scope.accountContent.userInfo.data;
      userInfoData.isPremiumUser = $scope.accountContent.subscriptionInfo;
      if (userInfoData.isPremiumUser) {
        userInfoData.subscriptionTypeName = premiumService.getMembershipMapping(
          $scope.accountContent.subscriptionInfo.subscriptionTypeName
        );
        userInfoData.subscriptionRenewal = $scope.accountContent.subscriptionInfo.renewal
          ? languageResource.intl.d(
              new Date($scope.accountContent.subscriptionInfo.renewal),
              'short'
            )
          : null;
        userInfoData.subscriptionExpiration = languageResource.intl.d(
          new Date($scope.accountContent.subscriptionInfo.expiration),
          'short'
        );
      }
    }
  }

  // string constants
  $scope.helpUrl = 'https://en.help.roblox.com/entries/22631829';

  // setup
  $scope.cancelRenewalUrl = angular
    .element(document.getElementById('state-properties'))
    .attr('data-cancelrenewalurl');

  $scope.showBlockedUsers = false;

  $scope.populateAccount = accountsService.populateAccount;

  $scope.themeContent = {
    newThemeType: accountConstantsResources.defaultThemeType,
    oldThemeType: accountConstantsResources.defaultThemeType,
    availableThemes: []
  };

  $scope.accountPinContent = {
    isEnabled: false,
    isUnlocked: false,
    unlockedUntil: null,
    pinLength: 4
  };

  $scope.parentContent = {
    accountRestrictions: {
      isFeatureEnabled: false
    }
  };

  $scope.twoStepContent = {
    isEnabled: false
  };

  $scope.connectedAccounts = {
    isConnectedAccountsBoxShown: false,
    providerName: '',
    userName: ''
  };

  $scope.processErrorMessage = function(error) {
    let errorMsg = error;
    if (error && error.errors && error.errors[0] && error.errors[0].message) {
      errorMsg = error.errors[0].message;
    }
    return errorMsg;
  };

  $scope.gigyaUserInfo = function() {
    gigya.socialize.getUserInfo({
      callback(response) {
        const username = response && response.user ? response.user.nickname : '';
        $timeout(function() {
          $scope.connectedAccounts.providers.forEach(function(provider) {
            if (
              provider.provider.toLowerCase() ===
              accountConstantsResources.socialAuth.providers.facebook
            ) {
              provider.identifier = username;
            }
          });
        });
      }
    });
  };

  $scope.xbox = {
    isDisconnectXboxEnabled: false,
    isDisconnectXboxBoxShown: false
  };

  // account content
  $scope.accountContent = {
    userInfo: {},
    hasEmailButNotVerified: false,
    hasVerfiedEmail: false,
    hasPassword: true
  };

  $scope.pinFields = {
    pinOne: '',
    pinTwo: '',
    pinThree: '',
    pinFour: ''
  };

  $scope.passwordInfo = {
    newPassword: '',
    currentPassword: ''
  };

  $scope.notificationSettings = {
    notificationBandSettings: [],
    optedOutNotificationSourceTypes: [],
    optedOutReceiverDestinationTypes: [],
    updatedDestinationTypeOptOuts: {}
  };

  $scope.notificationSourceTypeMapping = {};

  $scope.receiverDestinationTypeMapping = [];

  // V2
  $scope.contactSettings = {};
  $scope.joinSettings = {};
  $scope.accountRestrictions = {};
  $scope.socialNetworks = {};
  $scope.tradeSettings = {};
  $scope.inventorySettings = {};
  $scope.accountInfoSettings = {};

  $scope.accountSettingsPolicy = accountConstantsResources.accountSettingsPolicyLeastPrivileged;

  $scope.personal = {
    description: '',
    birthdate: {},
    gender: {},
    country: {}
  };

  $scope.isV2Enabled = {
    socialNetworks: false
  };
  // V2

  $scope.allActiveCountryList = {};

  $scope.accountInformationMetadata = {
    isAllowedNotificationsEndpointDisabled: false,
    isAccountSettingsPolicyEnabled: false,
    isPhoneNumberEnabled: false
  };

  $scope.addOrChangePhone = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.addOrChangePhone, retryPinUnlockLimit);
      return;
    }

    $scope.phoneModalData = angular.extend($scope.phoneModalData, {
      codeLength: $scope.accountInfoSettings.verificationCodeLength
    });

    const modalParams = {
      templateUrl: accountConstantsResources.templates.modal.phoneSet,
      controller: accountConstantsResources.controllers.modal.phoneSet,
      scope: $scope
    };

    $uibModal.open(modalParams).result.then(function(data) {
      BootstrapWidgets.ToggleSystemMessage($('.alert-success'), 100, 3000, data.message);
      $scope.getPhoneNumber();
    });
  };

  $scope.showSuccess = function() {
    const text = languageResource.get('Description.SuccessDialogMessage');
    systemFeedbackService.success(text, 100, 1000);
  };

  $scope.setAccountInfo = function(data) {
    $scope.accountContent.userInfo = {
      data,
      hasError: false
    };

    setUserSubscriptionInfo();

    // Email
    $scope.accountContent.hasVerifiedEmail =
      $scope.accountContent.userInfo.data.IsEmailOnFile &&
      $scope.accountContent.userInfo.data.IsEmailVerified;
    $scope.accountContent.hasEmailButNotVerified =
      $scope.accountContent.userInfo.data.IsEmailOnFile &&
      !$scope.accountContent.userInfo.data.IsEmailVerified;

    $scope.setXboxConnectionUrls($scope.accountContent.userInfo.data.AuthDomain);
    $scope.setNotificationSettingsUrls(
      $scope.accountContent.userInfo.data.NotificationSettingsDomain
    );
    angular.forEach($scope.accountContent.userInfo.data.AllowedNotificationSourceTypes, function(
      item
    ) {
      $scope.notificationSourceTypeMapping[item] = _notificationSourceTypeMapping[item];
    });
    $scope.receiverDestinationTypeMapping = _receiverDestinationTypeMapping.filter(function(value) {
      const found =
        $scope.accountContent.userInfo.data.AllowedReceiverDestinationTypes.indexOf(
          value.destinationType
        ) !== -1;
      if (found) {
        const notificationPolicyKey =
          accountConstantsResources.accountSettingsPolicyNotificationDestinations[
            value.destinationType
          ];
        if (notificationPolicyKey) {
          return $scope.accountSettingsPolicy[notificationPolicyKey];
        }
      }
      return false;
    });
    $scope.desktopPushSettings = {
      minimumChromeVersion: data.MinimumChromeVersionForPushNotifications,
      enabledOnFirefox: data.PushNotificationsEnabledOnFirefox
    };
    $scope.percentTranslator = function(aDouble) {
      return aDouble == null ? '-' : languageResource.intl.n(aDouble, 'percent');
    };
    $scope.dateMonthTranslator = function(rawDateMs) {
      return languageResource.intl.d(new Date(rawDateMs), { month: 'long' });
    };
    $scope.dateYearTranslator = function(rawDateMs) {
      return languageResource.intl.d(new Date(rawDateMs), { year: 'numeric' });
    };
    $scope.getNotificationSettings();
    $scope.setAccountSettingsApiUrl($scope.accountContent.userInfo.data.AccountSettingsApiDomain);
    get2SvSetting();
    $scope.setAuthDomainUrl($scope.accountContent.userInfo.data.AuthDomain);
    if ($scope.accountContent.userInfo.data.IsAccountPinEnabled) {
      $scope.getAccountPinSetting();
    }
    $scope.setUpSocialDisconnect();
    $scope.getXboxConnection();

    $scope.getAccountRestrictions();
    $scope.getCurrentTheme();
    $scope.getAvailableThemes();

    $scope.prepForV2(data);
    displayInitialModals();
  };

  $scope.getAccountInfo = function() {
    accountsService.beginGetAccountInfo().then(
      function(result) {
        $scope.setAccountInfo(result);
      },
      function(error) {
        $scope.accountContent.userInfo = {
          data: error,
          hasError: true
        };
      }
    );
  };

  $scope.getAccountSubscription = function() {
    premiumService.getUserStatus().then(function(data) {
      $scope.accountContent.subscriptionInfo = data ? data.subscriptionProductModel : null;
      setUserSubscriptionInfo();
    });
  };

  $scope.handleCancelBtnClicked = function() {
    const premiumFeatureId = $scope.accountContent.userInfo.data.PremiumFeatureId;
    if (FormEvents && premiumFeatureId) {
      FormEvents.SendInteractionClick('cancelRenewal', { pid: premiumFeatureId });
    }
  };

  $scope.isAnyMembership = function() {
    if (
      $scope.accountContent &&
      $scope.accountContent.userInfo &&
      $scope.accountContent.userInfo.data
    ) {
      return $scope.accountContent.userInfo.data.isPremiumUser;
    }
    return false;
  };

  $scope.isMembershipRenewal = function() {
    if (
      $scope.accountContent &&
      $scope.accountContent.userInfo &&
      $scope.accountContent.userInfo.data
    ) {
      return $scope.accountContent.userInfo.data.subscriptionRenewal;
    }
    return false;
  };

  // V2

  $scope.prepForV2 = function(result) {
    // For move to V2
    $scope.isV2Enabled.socialNetworks = result.IsAccountSettingsSocialNetworksV2Enabled;

    // For phone
    $scope.accountContent.isPhoneFeatureEnabled = result.IsPhoneFeatureEnabled;

    $scope.getAccountInfoSettings();
    $scope.getPersonalSettings();
    $scope.getJoinSettings();
    $scope.getTradeSettings();
    $scope.getInventorySettings();
    $scope.getContactSettings();
    $scope.getPrivacySettingsInfo();
    $scope.getPrivacySettings();
    $scope.getSocialNetworks();
  };

  $scope.getAccountInfoSettings = function() {
    $scope.getPhoneNumber();
  };

  $scope.getPhoneNumber = function() {
    accountsService.beginGetPhone().then(
      function(result) {
        if ($scope.accountContent.userInfo.data.UserAbove13) {
          $scope.accountInfoSettings.isPhoneNumberVisible = true;
          $scope.accountInfoSettings.countryCode = result.countryCode;
          $scope.accountInfoSettings.prefix = result.prefix;
          $scope.accountInfoSettings.phone = result.phone;
          $scope.accountInfoSettings.isPhoneVerified = result.isVerified;
          $scope.accountInfoSettings.verificationCodeLength = result.verificationCodeLength;
        }
      },
      function(error) {
        $log.debug('Error getting phone');
      }
    );
  };

  $scope.getPersonalSettings = function() {
    if ($scope.isDateTimeI18nPickerEnabled()) {
      $scope.populateAccount.orderedBirthdayParts = {
        parts: accountConstantsResources.defaultDateParts, // object containing keys 0, 1, and 2 for the ordered date options for dropdown date pickers
        typeOrder: new Intl().getDateTimeFormatter().getOrderedDateParts() // array where position 0/1/2 represents ordering for year/month/day
      };
    }

    accountsService.beginGetDescription().then(
      function(result) {
        $scope.personal.description = result.description;
      },
      function(error) {
        $log.debug('Error getting personal description');
      }
    );

    accountsService.beginGetBirthdate().then(
      function(result) {
        const { birthdate } = $scope.personal;
        birthdate.birthDay = result.birthDay;
        birthdate.birthMonth = result.birthMonth;
        birthdate.birthYear = result.birthYear;
        $scope.personal.birthdate.fullBirthdate = function() {
          const d = new Date(birthdate.birthYear, birthdate.birthMonth - 1, birthdate.birthDay);
          return d;
        };
        $scope.populateDays();
        $scope.populateMonths();
        $scope.populateYears();
        birthdate.originalBirthdate = birthdate.fullBirthdate();
      },
      function(error) {
        $log.debug('Error getting personal birthdate');
      }
    );

    accountsService.beginGetCountry().then(
      function(result) {
        if (result.success) {
          let countryId = 0;
          if (result.countryId) {
            countryId = result.countryId;
          }
          $scope.personal.country.countryId = countryId;
        } else {
          $log.debug(`Failed to get personal country. Message : ${result.errorMessage}`);
        }
      },
      function(error) {
        $log.debug('Error getting personal country');
      }
    );

    accountsService.beginGetGender().then(
      function(result) {
        $scope.personal.gender = result.gender.toString();
      },
      function(error) {
        $log.debug('Error getting personal gender');
      }
    );
  };

  $scope.updateDescription = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.updateDescription, retryPinUnlockLimit);
      return;
    }

    accountsService.beginUpdateDescription($scope.personal.description).then(
      function(result) {
        displayInfoModal(
          modalConstantsService.default.success.title,
          modalConstantsService.default.success.body
        );
      },
      function(error) {
        displayInfoModal(
          modalConstantsService.default.error.title,
          modalConstantsService.default.error.body
        );
        $log.debug('Error updating personal description');
      }
    );
  };

  $scope.updateBirthdate = function() {
    const restoreOriginalBirthday = function() {
      $scope.personal.birthdate.birthMonth =
        $scope.personal.birthdate.originalBirthdate.getMonth() + 1;
      $scope.personal.birthdate.birthDay = $scope.personal.birthdate.originalBirthdate.getDate();
      $scope.personal.birthdate.birthYear = $scope.personal.birthdate.originalBirthdate.getFullYear();
      $scope.populateDays();
    };

    /**
     * clamp day to closest valid value if it exceeds the limit (ex Apr 31st -> Apr 30th)
     * @function
     * @param {number} year in YYYY format
     * @param {number} month index 1-12
     * @param {number} day index 1-31
     * @returns {Object} Clamped Date object
     */
    const getClosestValidDay = function(year, month, day) {
      let currentDay = day;
      const currentMonth = month - 1;
      let tempDate = new Date(year, currentMonth, day, 0, 0, 0, 0);
      if (tempDate.getMonth() > currentMonth) {
        while (tempDate.getMonth() !== currentMonth) {
          currentDay--;
          tempDate = new Date(year, currentMonth, currentDay, 0, 0, 0, 0);
        }
      }
      return tempDate;
    };
    const clampedDate = getClosestValidDay(
      $scope.personal.birthdate.birthYear,
      $scope.personal.birthdate.birthMonth,
      $scope.personal.birthdate.birthDay
    );
    $scope.personal.birthdate.birthMonth = clampedDate.getMonth() + 1;
    $scope.personal.birthdate.birthDay = clampedDate.getDate();
    $scope.personal.birthdate.birthYear = clampedDate.getFullYear();

    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting(
        $scope.updateBirthdate,
        retryPinUnlockLimit,
        restoreOriginalBirthday
      );
      return;
    }

    const updateBirthdateConfirm = function(isChangeOver13ToUnder13) {
      accountsService.beginUpdateBirthdate($scope.personal.birthdate).then(
        function(result) {
          if (isChangeOver13ToUnder13) {
            $window.location.reload();
          }

          const { birthdate } = $scope.personal;
          birthdate.fullBirthdate = function() {
            const d = new Date(birthdate.birthYear, birthdate.birthMonth - 1, birthdate.birthDay);
            return d;
          };
          birthdate.originalBirthdate = birthdate.fullBirthdate();
          $scope.populateDays();
        },
        function(error) {
          displayInfoModal(
            modalConstantsService.default.error.title,
            modalConstantsService.default.error.body
          );
          restoreOriginalBirthday();
          $log.debug('Error updating personal birthdate');
        }
      );
    };

    const isChangeOver13ToUnder13 =
      $scope.personal.birthdate.originalBirthdate &&
      $scope.calculateAge($scope.personal.birthdate.originalBirthdate) >= 13 &&
      $scope.calculateAge($scope.personal.birthdate.fullBirthdate()) < 13;

    if (isChangeOver13ToUnder13) {
      // prevent age down
      if (!$scope.accountContent.userInfo.data.IsAgeDownEnabled) {
        restoreOriginalBirthday();
        displayInfoModal(
          modalConstantsService.default.error.title,
          languageResource.get('ResponseAgeDownError')
        );
      } else {
        accountsService
          .beginGetSocialConnected()
          .then(function(result) {
            let modal;
            if (
              result &&
              result.providers &&
              result.providers[0] &&
              result.providers[0].provider.toLowerCase() ===
                accountConstantsResources.socialAuth.providers.facebook
            ) {
              // If the user is connected to Facebook login
              if ($scope.accountContent.userInfo.data.IsSetPasswordNotificationEnabled) {
                modal = modalService.open({
                  titleText: modalConstantsService.birthdayChange.needPassword.title,
                  bodyText: modalConstantsService.birthdayChange.needPassword.body
                });
              } else {
                modal = modalService.open({
                  titleText: modalConstantsService.birthdayChange.default.title,
                  bodyText: modalConstantsService.birthdayChange.withSocialSignOn.body,
                  actionButtonShow: true,
                  actionButtonText:
                    modalConstantsService.birthdayChange.withSocialSignOn.positiveBtnText, // This is correct, we want "Ok" to be a negative action because it is bad
                  neutralButtonText:
                    modalConstantsService.birthdayChange.withSocialSignOn.negativeBtnText
                });
              }
            } else {
              modal = modalService.open({
                titleText: modalConstantsService.birthdayChange.default.title,
                bodyText: modalConstantsService.birthdayChange.default.body,
                actionButtonShow: true,
                actionButtonText: modalConstantsService.default.positiveBtnText, // This is correct, we want "Yes" to be a negative action because it is bad
                neutralButtonText: modalConstantsService.default.negativeBtnText
              });
            }
            return modal.result;
          })
          .then(function() {
            updateBirthdateConfirm(isChangeOver13ToUnder13);
          })
          .catch(restoreOriginalBirthday);
      }
    } else {
      updateBirthdateConfirm(isChangeOver13ToUnder13);
    }
  };

  $scope.updateGender = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.updateGender, retryPinUnlockLimit);
      return;
    }

    accountsService.beginUpdateGender($scope.personal.gender).then(
      function(result) {
        $scope.showSuccess();
      },
      function(error) {
        $log.debug('Error updating gender');
      }
    );
  };

  $scope.updateCountry = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.updateCountry, retryPinUnlockLimit);
      return;
    }
    if ($scope.personal.country.countryId <= 0) {
      return;
    }
    accountsService.beginUpdateCountry($scope.personal).then(
      function(result) {
        if (!result.success) {
          $log.debug(`Failed to update country. Message: ${result.errorMessage}`);
        } else {
          $scope.getPrivacySettingsInfo();
        }
      },
      function(error) {
        $log.debug('Error updating country');
      }
    );
  };

  $scope.getCurrentTheme = function() {
    accountsService.beginGetConsumerThemes().then(
      function(result) {
        let themeTypeFromResult = result.themeType;
        if (themeTypeFromResult === accountConstantsResources.themeTypes.classic) {
          themeTypeFromResult = $scope.accountData.stateProperties.defaultThemeType;
        }
        $scope.themeContent.newThemeType = themeTypeFromResult;
        $scope.themeContent.oldThemeType = themeTypeFromResult;
      },
      function() {
        modalService.open({
          titleText: modalConstantsService.default.error.title,
          bodyText: modalConstantsService.default.error.body
        });
      }
    );
  };

  $scope.getAvailableThemes = function() {
    accountsService.beginGetAvailableThemeTypes().then(
      function(result) {
        const { themes } = $scope.populateAccount;
        const filteredThemes = [];
        themes.forEach(function(theme) {
          if (result.data.indexOf(theme.value) !== -1) {
            filteredThemes.push(theme);
          }
        });
        $scope.themeContent.availableThemes = filteredThemes;
      },
      function() {
        modalService.open({
          titleText: modalConstantsService.default.error.title,
          bodyText: modalConstantsService.default.error.body
        });
      }
    );
  };

  $scope.getContactSettings = function() {
    accountsService.beginGetContactSettings().then(
      function(result) {
        $scope.contactSettings.AppChatPrivacy = result.appChatPrivacy;
        $scope.contactSettings.GameChatPrivacy = result.gameChatPrivacy;
        $scope.contactSettings.PrivateMessagePrivacy = result.privateMessagePrivacy;
        $scope.setContactSettingsMasterSetting();
      },
      function(error) {
        $log.debug('Error getting contact settings');
      }
    );
  };

  $scope.getPrivacySettingsInfo = function() {
    $scope.contactSettings.IsPhoneDiscoveryPrivacySettingEnabled = false;
    accountsService.beginGetPrivacySettingsInfo().then(
      function(result) {
        $scope.contactSettings.IsPhoneDiscoveryPrivacySettingEnabled =
          result.isPhoneDiscoveryEnabled;
      },
      function(error) {
        $log.debug('Error getting privacy settings');
      }
    );
  };

  $scope.getPrivacySettings = function() {
    accountsService.beginGetPrivacySettings().then(
      function(result) {
        $scope.contactSettings.PhoneDiscoveryPrivacy = result.phoneDiscovery;
        $scope.setContactSettingsMasterSetting();
      },
      function(error) {
        $log.debug('Error getting privacy settings');
      }
    );
  };

  $scope.onContactSettingsMasterSettingChange = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting(
        $scope.onContactSettingsMasterSettingChange,
        retryPinUnlockLimit
      );
      return;
    }

    const value = $scope.contactSettings.MasterSetting;

    if (value === defaultText) {
      $scope.contactSettings.PrivateMessagePrivacy = friendsText;
      $scope.contactSettings.AppChatPrivacy = friendsText;
      $scope.contactSettings.GameChatPrivacy = allUsersText;
      if ($scope.accountContent.userInfo.data.UserAbove13) {
        $scope.contactSettings.PhoneDiscoveryPrivacy = allUsersText;
      }
    } else if (value === offText) {
      $scope.contactSettings.PrivateMessagePrivacy = noOneText;
      $scope.contactSettings.AppChatPrivacy = noOneText;
      $scope.contactSettings.GameChatPrivacy = noOneText;
      if ($scope.accountContent.userInfo.data.UserAbove13) {
        $scope.contactSettings.PhoneDiscoveryPrivacy = noOneText;
      }
    }

    if (value !== customText) {
      const appChatPrivacyUpdateRequest = accountsService.beginUpdateAppChatPrivacy(
        $scope.contactSettings
      );
      appChatPrivacyUpdateRequest.then(
        function(result) {},
        function(error) {
          $log.debug('Error updating app chat privacy');
        }
      );

      const gameChatPrivacyRequest = accountsService.beginUpdateGameChatPrivacy(
        $scope.contactSettings
      );
      gameChatPrivacyRequest.then(
        function(result) {},
        function(error) {
          $log.debug('Error updating game chat privacy');
        }
      );

      const privateMessagePrivacyRequest = accountsService.beginUpdatePrivateMessagePrivacy(
        $scope.contactSettings
      );
      privateMessagePrivacyRequest.then(
        function(result) {},
        function(error) {
          $log.debug('Error updating private message privacy');
        }
      );

      if ($scope.accountContent.userInfo.data.UserAbove13) {
        var contactPrivacyRequest = accountsService.beginUpdatePrivacySettings(
          $scope.contactSettings
        );
        contactPrivacyRequest.then(
          function(result) {},
          function(error) {
            $log.debug('Error updating privacy settings');
          }
        );
      }

      const promises = $q.all([
        appChatPrivacyUpdateRequest,
        gameChatPrivacyRequest,
        privateMessagePrivacyRequest,
        contactPrivacyRequest
      ]);
      promises.then(
        function() {
          $scope.showSuccess();
        },
        function() {
          $log.debug('Error switching master contact setting');
          const unknownErrorText = languageResource.get('MessageUnknownError');
          systemFeedbackService.warning(unknownErrorText, 5000);
        }
      );

      return promises;
    }
  };

  $scope.updateAppChatPrivacy = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.updateAppChatPrivacy, retryPinUnlockLimit);
      return;
    }
    $scope.contactSettings.MasterSetting = customText;
    accountsService.beginUpdateAppChatPrivacy($scope.contactSettings).then(
      function(result) {
        $scope.showSuccess();
      },
      function(error) {
        $log.debug('Error updating app chat privacy');
      }
    );
  };

  $scope.updateGameChatPrivacy = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.updateGameChatPrivacy, retryPinUnlockLimit);
      return;
    }
    $scope.contactSettings.MasterSetting = customText;
    accountsService.beginUpdateGameChatPrivacy($scope.contactSettings).then(
      function(result) {
        $scope.showSuccess();
      },
      function(error) {
        $log.debug('Error updating game chat privacy');
      }
    );
  };

  $scope.updatePrivacySettings = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.updatePrivacySettings, retryPinUnlockLimit);
      return;
    }
    $scope.contactSettings.MasterSetting = customText;
    accountsService.beginUpdatePrivacySettings($scope.contactSettings).then(
      function(result) {
        $scope.showSuccess();
      },
      function(error) {
        $log.debug('Error updating privacy settings.');
      }
    );
  };

  $scope.updatePrivateMessagePrivacy = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.updatePrivateMessagePrivacy, retryPinUnlockLimit);
      return;
    }
    $scope.contactSettings.MasterSetting = customText;
    accountsService.beginUpdatePrivateMessagePrivacy($scope.contactSettings).then(
      function(result) {
        $scope.showSuccess();
      },
      function(error) {
        $log.debug('Error updating private message privacy');
      }
    );
  };

  $scope.getJoinSettings = function() {
    accountsService.beginGetPrivateServerInvitePrivacy().then(
      function(result) {
        $scope.joinSettings.privateServerInvitePrivacy = result.PrivateServerInvitePrivacy;
      },
      function(error) {
        $log.debug('Error getting private server invite privacy');
      }
    );
    accountsService.beginGetFollowMePrivacy().then(
      function(result) {
        $scope.joinSettings.followMePrivacy = result.FollowMePrivacy;
      },
      function(error) {
        $log.debug('Error getting follow me privacy');
      }
    );
  };

  $scope.updatePrivateServerInvitePrivacy = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.updatePrivateServerInvitePrivacy, retryPinUnlockLimit);
      return;
    }
    accountsService.beginUpdatePrivateServerInvitePrivacy($scope.joinSettings).then(
      function(result) {
        $scope.showSuccess();
      },
      function(error) {
        $log.debug('Error updating private server invite privacy');
      }
    );
  };

  $scope.updateFollowMePrivacy = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.updateFollowMePrivacy, retryPinUnlockLimit);
      return;
    }
    accountsService.beginUpdateFollowMePrivacy($scope.joinSettings).then(
      function(result) {
        $scope.showSuccess();
      },
      function(error) {
        $log.debug('Error updating follow me privacy');
      }
    );
  };

  $scope.getTradeSettings = function() {
    accountsService.beginGetTradePrivacy().then(
      function(result) {
        $scope.tradeSettings.tradePrivacy = result.tradePrivacy;
      },
      function(error) {
        $log.debug('Error getting trade privacy');
      }
    );
    accountsService.beginGetTradeValue().then(
      function(result) {
        $scope.tradeSettings.tradeValue = result.tradeValue;
      },
      function(error) {
        $log.debug('Error getting trade value');
      }
    );
  };

  $scope.updateTradePrivacy = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.updateTradePrivacy, retryPinUnlockLimit);
      return;
    }
    accountsService.beginUpdateTradePrivacy($scope.tradeSettings).then(
      function(result) {
        if (result.privacySettingResponse === 'Conflict') {
          $scope.inventorySettings.inventoryPrivacy = result.inventoryPrivacy;
          const popupMessage = accountsService.getUpdateInventoryPrivacyMessageWhenConflict();
          systemFeedbackService.success(popupMessage, 300, 5000);
        } else {
          $scope.showSuccess();
        }
      },
      function(error) {
        $log.debug('Error updating trade privacy');
      }
    );
  };

  $scope.updateTradeValue = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.updateTradeValue, retryPinUnlockLimit);
      return;
    }
    accountsService.beginUpdateTradeValue($scope.tradeSettings).then(
      function(result) {
        $scope.showSuccess();
      },
      function(error) {
        $log.debug('Error updating trade value');
      }
    );
  };

  $scope.getSocialNetworks = function() {
    accountsService.beginGetPromotionChannels().then(
      function(result) {
        $scope.socialNetworks.SocialNetworksVisibilityPrivacy =
          result.promotionChannelsVisibilityPrivacy;
        $scope.socialNetworks.FacebookUrl = result.facebook;
        $scope.socialNetworks.TwitterUrl = result.twitter;
        $scope.socialNetworks.YouTubeUrl = result.youtube;
        $scope.socialNetworks.TwitchUrl = result.twitch;
      },
      function(error) {
        $log.debug('Error getting social networks');
      }
    );
  };

  $scope.getInventorySettings = function() {
    accountsService.beginGetInventoryPrivacy().then(
      function(result) {
        $scope.inventorySettings.inventoryPrivacy = result.inventoryPrivacy;
      },
      function(error) {
        $log.debug('Error getting inventory privacy');
      }
    );
  };

  $scope.updateInventoryPrivacy = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.updateInventoryPrivacy, retryPinUnlockLimit);
      return;
    }
    accountsService.beginUpdateInventoryPrivacy($scope.inventorySettings).then(
      function(result) {
        if (result.privacySettingResponse === 'Conflict') {
          $scope.tradeSettings.tradePrivacy = result.tradePrivacy;
          const popupMessage = accountsService.getUpdateTradePrivacyMessageWhenConflict();
          systemFeedbackService.success(popupMessage, 300, 5000);
        } else {
          $scope.showSuccess();
        }
      },
      function(error) {
        $log.debug('Error updating inventory privacy');
      }
    );
  };

  $scope.updateSocialNetworks = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.updateSocialNetworks, retryPinUnlockLimit);
      return;
    }

    accountsService.beginUpdatePromotionChannels($scope.socialNetworks).then(
      function() {
        displayInfoModal(
          modalConstantsService.default.success.title,
          modalConstantsService.default.success.body
        );
      },
      function(error) {
        let errorMsg = error || socialNetworkErrorMessage;
        if (error && error.errors && error.errors[0] && error.errors[0].message) {
          const errorCode = error.errors[0].code;

          const errorMsgLangKey = accountConstantsResources.socialErrorCode[errorCode];
          errorMsg = errorMsgLangKey
            ? languageResource.get(errorMsgLangKey)
            : languageResource.get('MessageUnknownError');
        }
        displayInfoModal(modalConstantsService.default.error.title, errorMsg);
      }
    );
  };

  $scope.convertDate = function(dateString) {
    const parsedInt = parseInt(dateString.replace(/(^.*\()|([+-].*$)/g, ''));
    const value = new Date(parsedInt);
    const utcValue = new Date(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate());
    return $filter('datetime')(utcValue); // datetime filter gets the i18n date
  };

  $scope.currentDate = new Date();

  $scope.calculateAge = function(birthday) {
    // birthday is a date
    // http://stackoverflow.com/a/24883386
    const ageDifMs = Date.now() - birthday.getTime();
    const ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  };

  $scope.isAsianBirthdayPickerEnabled = function() {
    return intl && intl.isAsianLanguage();
  };

  $scope.isDateTimeI18nPickerEnabled = function() {
    return (
      $scope.accountContent.userInfo.data &&
      $scope.accountContent.userInfo.data.IsDateTimeI18nPickerEnabled
    );
  };

  $scope.populateYears = function() {
    const date = parseInt($filter('date')(new Date(), 'yyyy'));
    for (let i = 0; i < 100; i++) {
      $scope.populateAccount.years[i] = {
        name: $scope.isAsianBirthdayPickerEnabled()
          ? intl.getFormattedDateString(date - i, languageResource.get('Label.Year'))
          : date - i,
        value: date - i
      };
    }
    if ($scope.isDateTimeI18nPickerEnabled()) {
      $scope.setOrderedBirthdayPart('year', $scope.populateAccount.years);
    }
  };

  $scope.populateDays = function() {
    const year = $scope.personal.birthdate.birthYear;
    const month = $scope.personal.birthdate.birthMonth - 1;
    const date = new Date(year, month + 1, 0);
    if ($scope.personal.birthdate.birthDay > date.getDate()) {
      $scope.personal.birthdate.birthDay = date.getDate();
    }
    $scope.populateAccount.days = [];
    for (let i = 0; i < date.getDate(); i++) {
      $scope.populateAccount.days[i] = {
        name: $scope.isAsianBirthdayPickerEnabled()
          ? intl.getFormattedDateString(i + 1, languageResource.get('Label.Day'))
          : i + 1,
        value: i + 1
      };
    }

    if ($scope.isDateTimeI18nPickerEnabled()) {
      $scope.setOrderedBirthdayPart('day', $scope.populateAccount.days);
    }
  };

  $scope.populateMonths = function() {
    if ($scope.isDateTimeI18nPickerEnabled()) {
      const intl = Intl && new Intl();
      const months = intl
        ? intl.getMonthsI18n('short', languageResource.get('Label.Month'))
        : languageResource.intl.getMonthsList();

      $scope.setOrderedBirthdayPart('month', months);
    }
  };

  $scope.setOrderedBirthdayPart = function(partName, value) {
    // use type order position to determine which position {partName} dropdown options {value} will be placed (0/1/2)
    const partIndex = $scope.populateAccount.orderedBirthdayParts.typeOrder[partName];

    $scope.populateAccount.orderedBirthdayParts.parts[partIndex] = {
      options: value,
      idName: accountConstantsResources.birthdayPicker[partName].id,
      className: accountConstantsResources.birthdayPicker[partName].class,
      birthdayName: accountConstantsResources.birthdayPicker[partName].name
    };
  };

  $scope.signOutFromSessions = function() {
    accountsService.beginAccountSignOut().then(
      function(result) {
        displayInfoModal(
          modalConstantsService.default.success.title,
          modalConstantsService.secureSignOut.success.body
        );
      },
      function(error) {
        displayInfoModal(
          modalConstantsService.default.error.title,
          modalConstantsService.secureSignOut.error.body
        );
      }
    );
  };

  $scope.disconnectFromFb = function() {
    accountsService
      .beginUpdateSocialDisconnect(accountConstantsResources.socialAuth.providers.facebook)
      .then(
        function(result) {
          $scope.refreshPage();
        },
        function(error) {
          console.info(error);
          displayInfoModal(
            modalConstantsService.default.error.title,
            $scope.processErrorMessage(error)
          );
        }
      );
  };

  $scope.initiateFbDisconnect = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.initiateFbDisconnect, retryPinUnlockLimit);
      return;
    }

    // If the user doesn't have a password set yet, we need to ask them to create password
    // before disconnecting from FB so they can access account.
    if ($scope.accountContent.userInfo.data.IsSetPasswordNotificationEnabled) {
      const modal = $uibModal.open({
        templateUrl: accountConstantsResources.templates.modal.passwordSet,
        controller: accountConstantsResources.controllers.modal.passwordSet,
        resolve: {
          modalData: {
            facebookDisconnect: true,
            changePassword: !$scope.accountContent.userInfo.data.IsSetPasswordNotificationEnabled,
            doesPasswordExist: $scope.accountContent.userInfo.data.HasValidPasswordSet
          }
        }
      });
      modal.result.finally(function() {
        accountsService.beginGetAccountInfo().then(
          function(result) {
            $scope.setAccountInfo(result);
            if (!$scope.accountContent.userInfo.data.IsSetPasswordNotificationEnabled) {
              $scope.disconnectFromFb();
            }
          },
          function(error) {
            $scope.accountContent.userInfo = {
              data: error,
              hasError: true
            };
          }
        );
      });
    } else {
      $scope.disconnectFromFb();
    }
  };

  $scope.disconnectFromProvider = function(provider) {
    if (provider.toLowerCase() === accountConstantsResources.socialAuth.providers.facebook) {
      // Facebook disconnect does not require the user to enter their current password to disconnect
      $scope.initiateFbDisconnect();
    } else {
      // Other providers require that the user to enter their current password
      const modal = $uibModal.open({
        templateUrl: accountConstantsResources.templates.modal.socialDisconnect,
        controller: accountConstantsResources.controllers.modal.socialDisconnect,
        resolve: {
          modalData: {
            provider
          }
        }
      });
      modal.result.then(function() {
        $window.location.reload();
      }, angular.noop);
    }
  };

  $scope.disconnectFromXbox = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.disconnectFromXbox, retryPinUnlockLimit);
      return;
    }

    accountsService.beginDisconnectXbox().then(function(result) {
      if (result.success) {
        $scope.refreshPage();
      } else {
        displayInfoModal(
          modalConstantsService.default.success.title,
          modalConstantsService.disconnectXbox.error.body
        );
      }
    });
  };

  $scope.chooseGender = function(gender) {
    $scope.personal.gender = gender;
    $scope.updateGender();
  };

  $scope.privacyModeInfo = function() {
    $window.open($scope.helpUrl, '_blank');
  };

  $scope.buyRobux = function(url) {
    $window.location.href = url;
  };

  $scope.refreshPage = function() {
    $scope.getAccountSubscription();
    $scope.getAccountInfo();
  };

  $scope.setPassword = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.setPassword, retryPinUnlockLimit);
      return;
    }

    const modal = $uibModal.open({
      templateUrl: accountConstantsResources.templates.modal.passwordSet,
      controller: accountConstantsResources.controllers.modal.passwordSet,
      resolve: {
        modalData: {
          facebookDisconnect: false,
          changePassword: !$scope.accountContent.userInfo.data.IsSetPasswordNotificationEnabled,
          doesPasswordExist: $scope.accountContent.userInfo.data.HasValidPasswordSet
        }
      }
    });

    modal.result.finally(function() {
      // TODO: Instead of refreshing page, just retrieve new password and update info that facebook disconnect needs
      $scope.refreshPage();
    });
  };

  $scope.changeUsername = function() {
    // Email doesn't exist
    if (
      !$scope.accountContent.userInfo.data.IsEmailOnFile &&
      $scope.accountContent.userInfo.data.HasFreeNameChange === false
    ) {
      $scope.setEmailAddress(modalConstantsService.changeUsername.missingEmail);

      // Email not verified
    } else if (
      !$scope.accountContent.userInfo.data.IsEmailVerified &&
      $scope.accountContent.userInfo.data.HasFreeNameChange === false
    ) {
      $scope.verifyEmailAddress(true, modalConstantsService.changeUsername.unverifiedEmail);

      // Currency Operation Error
    } else if (
      $scope.accountContent.userInfo.data.HasCurrencyOperationError &&
      $scope.accountContent.userInfo.data.HasFreeNameChange === false
    ) {
      const message = $scope.accountContent.userInfo.data.CurrencyOperationErrorMessage;
      displayInfoModal(
        'Currency Service Error',
        message || 'There was an error with the currency service. Try again later.'
      );

      // Users Service Issue
    } else if ($scope.accountContent.userInfo.data.HasFreeNameChange === null) {
      displayInfoModal(
        modalConstantsService.default.error.title,
        modalConstantsService.default.error.body
      );

      // Insufficient Robux
    } else if (
      $scope.accountContent.userInfo.data.RobuxRemainingForUsernameChange > 0 &&
      $scope.accountContent.userInfo.data.HasFreeNameChange === false
    ) {
      const robuxClass =
        $scope.accountContent.userInfo.data.IsNewRobuxIconEnabled == true
          ? 'icon-robux-16x16'
          : 'icon-robux';
      const robuxToBuy = `<span class="${robuxClass}"></span><span>${$scope.accountContent.userInfo.data.RobuxRemainingForUsernameChange}</span>`;
      var modal = modalService.open({
        titleText: modalConstantsService.changeUsername.changeUsernameTitle,
        bodyHtmlUnsafe: modalConstantsService.changeUsername.changeUsernameMessage({
          robuxToBuy
        }),
        actionButtonText: modalConstantsService.changeUsername.changeUsernameBuy,
        actionButtonShow: true,
        actionButtonClass: 'btn-primary-md',
        neutralButtonShow: false,
        cssClass: 'modal-insufficient-funds'
      });
      modal.result.then(function() {
        $scope.buyRobux($scope.accountData.stateProperties.buyRobuxUrl);
      });

      // Change Username Modal
    } else {
      if ($scope.pinIsEnabledAndLocked()) {
        $scope.unlockAccountPinSetting($scope.changeUsername, retryPinUnlockLimit);
        return;
      }

      var modal = $uibModal.open({
        templateUrl: accountConstantsResources.templates.modal.usernameUpdate,
        controller: accountConstantsResources.controllers.modal.usernameUpdate,
        resolve: {
          modalData: {
            userEmail: $scope.accountContent.userInfo.data.UserEmail,
            accountPinLength: $scope.accountPinContent.pinLength,
            doesPasswordExist: $scope.accountContent.userInfo.data.HasValidPasswordSet,
            isFreeUsernameChangeAllowed: $scope.accountContent.userInfo.data.HasFreeNameChange
          }
        }
      });

      modal.result.finally(function() {
        $scope.refreshPage();
        // TODO: Instead of refreshing page, just retrieve current username and previous usernames
      });
    }
  };

  $scope.verifyEmailAddress = function(verifiedEmailRequired, contextForVerification) {
    sendButtonClickEvent(accountConstantsResources.events.verifyEmailBtn);

    $uibModal.open({
      templateUrl: accountConstantsResources.templates.modal.emailVerify,
      controller: accountConstantsResources.controllers.modal.emailVerify,
      resolve: {
        modalData: {
          contextForVerification,
          verifiedEmailRequired
        }
      }
    });
  };

  $scope.setEmailAddress = function(action) {
    if ($scope.accountContent.userInfo.data.IsEmailOnFile) {
      sendButtonClickEvent(accountConstantsResources.events.changeEmailBtn);
    } else {
      sendButtonClickEvent(accountConstantsResources.events.addEmailBtn);
    }

    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.setEmailAddress, retryPinUnlockLimit);
      return;
    }

    const modal = $uibModal.open({
      templateUrl: accountConstantsResources.templates.modal.emailSet,
      controller: accountConstantsResources.controllers.modal.emailSet,
      resolve: {
        modalData: {
          emailRequired: !$scope.accountContent.userInfo.data.IsEmailOnFile && action,
          action,
          changeEmail: $scope.accountContent.userInfo.data.IsEmailOnFile,
          over13: $scope.accountContent.userInfo.data.UserAbove13,
          doesPasswordExist: $scope.accountContent.userInfo.data.HasValidPasswordSet
        }
      }
    });

    modal.result.finally(function() {
      $scope.refreshPage();
      // TODO: Instead of refreshing page, update accounts controller so that we can do:
      // if (!$scope.accountContent.userInfo.data.UserEmail) {
      //    $scope.accountContent.userInfo.data.UserEmail = updatedEmailInfo.emailAddress;
      //    $scope.accountContent.userInfo.data.IsEmailOnFile = true;
      //    $scope.accountContent.hasVerifiedEmail = false; // for the change email case
      //    $scope.accountContent.hasEmailButNotVerified = true;
      // }
    });
  };

  $scope.confirmEmail = function(message, action) {
    if ($scope.accountContent.hasEmailButNotVerified) {
      const modal = modalService.open({
        titleText: modalConstants.emailVerify.verifiedEmailRequiredTitle,
        bodyText: message,
        actionButtonShow: true,
        actionButtonText: modalConstants.emailVerify.unverifiedEmailButtonText,
        neutralButtonShow: false
      });

      modal.result.then(
        function() {
          $scope.verifyEmailAddress(false);
        },
        function() {
          // do nothing, they closed the modal
        }
      );
    } else {
      $scope.setEmailAddress(action);
    }
  };

  // Phone Numbers

  $scope.addPhone = function() {
    sendButtonClickEvent(accountConstantsResources.events.addPhoneBtn);
    $scope.phoneModalData = {
      action: modalConstantsService.phoneSet.addActionLabel,
      isAttemptToChangePhone: false
    };

    $scope.addOrChangePhone();
  };

  $scope.changePhone = function() {
    sendButtonClickEvent(accountConstantsResources.events.changePhoneBtn);

    $scope.phoneModalData = {
      action: modalConstantsService.phoneSet.editActionLabel,
      isAttemptToChangePhone: true,
      countryCode: $scope.accountInfoSettings.countryCode,
      prefix: $scope.accountInfoSettings.prefix,
      maskedNumber: $scope.accountInfoSettings.phone
    };

    $scope.addOrChangePhone();
  };

  // Blocked Users

  $scope.toggleBlockedUsers = function() {
    $scope.showBlockedUsers = !$scope.showBlockedUsers;
  };

  $scope.unBlock = function(uid) {
    accountsService.beginAccountUnblockUser(uid).then(
      function(result) {
        if (result.success === true) {
          // successfully unblocked user

          const blockedUsersModel = $scope.accountContent.userInfo.data.BlockedUsersModel;
          blockedUsersModel.Total -= 1;
          for (let i = 0; i < blockedUsersModel.BlockedUsers.length; i++) {
            if (blockedUsersModel.BlockedUsers[i].uid === uid) {
              blockedUsersModel.BlockedUsers[i].hidden = true;
            }
          }
        }
      },
      function(error) {
        $log.debug('There was an error.');
      }
    );
  };

  // Notifications
  $scope.getNotificationSettings = function() {
    if (
      $scope.receiverDestinationTypeMapping.length < 1 ||
      angular.equals($scope.notificationSourceTypeMapping, {})
    ) {
      return; // don't make the hcttp request if there are no rdt/nst allowed
    }
    accountsService.beginGetNotificationSettings().then(
      function(result) {
        $scope.notificationSettings = result;
        $scope.notificationSettings.updatedDestinationTypeOptOuts = {};
      },
      function(error) {
        $log.debug(error);
      }
    );
  };
  $scope.destinationNotificationBands = function(destinationType) {
    return $scope.notificationSettings.notificationBandSettings.filter(function(item) {
      return item.receiverDestinationType === destinationType;
    });
  };

  $scope.isNotificationBandBlacklisted = function(
    notificationSourceType,
    notificationDestinationType
  ) {
    if (notificationDestinationType === 'MobilePush') {
      const blacklist =
        $scope.accountContent.userInfo.data.BlacklistedNotificationSourceTypesForMobilePush;
      return blacklist.indexOf(notificationSourceType) >= 0;
    }
    return false;
  };

  $scope.setNotificationSettingsUrls = function(notificationsDomain) {
    accountsService.setNotificationSettingsUrls(notificationsDomain);
  };

  $scope.setXboxConnectionUrls = function(authDomain) {
    accountsService.setXboxConnectionUrls(authDomain);
  };

  $scope.setAuthDomainUrl = function(authDomain) {
    accountsService.setAuthDomainUrl(authDomain);
  };

  $scope.setAccountSettingsApiUrl = function(accountSettingsApiDomain) {
    accountsService.setAccountSettingsApiUrl(accountSettingsApiDomain);
  };

  $scope.isAvailable = function(receiverDestinationTypeMapping) {
    if (receiverDestinationTypeMapping.availabilityCheck) {
      return receiverDestinationTypeMapping.availabilityCheck();
    }
    return true;
  };
  $scope.isToggleable = function(receiverDestinationTypeMapping) {
    if (typeof receiverDestinationTypeMapping.isToggleable !== 'undefined') {
      return receiverDestinationTypeMapping.isToggleable();
    }
    return true;
  };
  $scope.isDestinationTypeOptedOut = function(receiverDestinationTypeMapping) {
    if (receiverDestinationTypeMapping.customEnabledCheck) {
      const value = receiverDestinationTypeMapping.customEnabledCheck(function(isSuccess) {
        $scope.$apply();
      });
      return !value;
    }

    const { destinationType } = receiverDestinationTypeMapping;
    return (
      $scope.notificationSettings.optedOutReceiverDestinationTypes.filter(function(item) {
        return item === destinationType;
      }).length > 0
    );
  };
  $scope.toggleDestinationTypeOptOut = function(receiverDestinationTypeMapping) {
    const { destinationType } = receiverDestinationTypeMapping;

    if ($scope.isDestinationTypeOptedOut(receiverDestinationTypeMapping)) {
      if (receiverDestinationTypeMapping.customEnablement) {
        receiverDestinationTypeMapping.customEnablement(function(isSuccess) {
          $scope.$apply();
        });
        return;
      }

      $scope.notificationSettings.updatedDestinationTypeOptOuts[
        destinationType
      ] = receiverDestinationTypeMapping;
      for (
        let i = 0;
        i < $scope.notificationSettings.optedOutReceiverDestinationTypes.length;
        i++
      ) {
        if ($scope.notificationSettings.optedOutReceiverDestinationTypes[i] === destinationType) {
          $scope.notificationSettings.optedOutReceiverDestinationTypes.splice(i, 1);
          return;
        }
      }
    } else {
      if (receiverDestinationTypeMapping.customDisablement) {
        receiverDestinationTypeMapping.customDisablement(function(isSuccess) {
          $scope.$apply();
        });
        return;
      }

      $scope.notificationSettings.updatedDestinationTypeOptOuts[
        destinationType
      ] = receiverDestinationTypeMapping;
      $scope.notificationSettings.optedOutReceiverDestinationTypes.push(destinationType);
    }
  };
  $scope.toggleNotificationBand = function(notificationBand) {
    if (notificationBand.isOverridable) {
      notificationBand.isSetByReceiver = true;
      notificationBand.isEnabled = !notificationBand.isEnabled;
    }
  };

  $scope.updateNotificationSettings = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.updateNotificationSettings, retryPinUnlockLimit);
      return;
    }

    const updatedNotificationBandSettings = $scope.notificationSettings.notificationBandSettings.filter(
      function(value) {
        return value.isSetByReceiver;
      }
    );
    const newlyAllowedDestinationTypes = [];
    const newlyOptedOutDestinationTypes = [];
    for (const key in $scope.notificationSettings.updatedDestinationTypeOptOuts) {
      if (
        $scope.isDestinationTypeOptedOut(
          $scope.notificationSettings.updatedDestinationTypeOptOuts[key]
        )
      ) {
        newlyOptedOutDestinationTypes.push(key);
      } else {
        newlyAllowedDestinationTypes.push(key);
      }
    }

    accountsService
      .beginUpdateNotificationSettings(
        updatedNotificationBandSettings,
        newlyOptedOutDestinationTypes,
        newlyAllowedDestinationTypes
      )
      .then(
        function() {
          $scope.refreshPage();
          displayInfoModal(
            notificationConstantsService.modalText.success.title,
            notificationConstantsService.modalText.success.body
          );
        },
        function() {
          // failure
          displayInfoModal(
            notificationConstantsService.modalText.error.title,
            notificationConstantsService.modalText.error.body
          );
        }
      );
  };

  $scope.setAccountPinSetting = function(result) {
    $scope.accountPinContent.isEnabled = result.isEnabled;
    $scope.accountPinContent.unlockedUntil = result.unlockedUntil;
    $scope.accountPinContent.isUnlocked = false;
    if (result.isEnabled && result.unlockedUntil) {
      $scope.accountPinContent.isUnlocked = true;
      $scope.startTimer(result.unlockedUntil);
    }
  };

  $scope.pinIsEnabledAndLocked = function() {
    return (
      $scope.accountPinContent.isEnabled &&
      !$scope.accountPinContent.isUnlocked &&
      $scope.accountContent.userInfo.data.IsAccountPinEnabled
    );
  };

  // GET STATUS OF PIN (ENABLED? UNLOCKED?)
  $scope.getAccountPinSetting = function() {
    accountsService.beginGetAccountPinSetting().then(
      function(result) {
        if (result) {
          $scope.setAccountPinSetting(result);
        }
      },
      function(error) {
        $log.debug(error);
      }
    );
  };

  // LOCK THE PIN - WHEN WE WANT TO LOCK THE PAGE
  $scope.lockAccountPinSetting = function() {
    accountsService.beginLockAccountPinSetting().then(
      function(result) {
        if (result) {
          $scope.accountPinContent.isUnlocked = false;
          $scope.accountPinContent.unlockedUntil = null;
          $scope.clearTimer();
        }
      },
      function(error) {
        $log.debug(error);
      }
    );
  };

  // UNLOCK THE PIN - WHEN WE WANT TO UNLOCK THE PAGE
  $scope.unlockAccountPinSetting = function(callback, retry, errorCallback) {
    $uibModal
      .open({
        templateUrl: accountConstantsResources.templates.modal.pinUnlock,
        controller: accountConstantsResources.controllers.modal.pinUnlock,
        resolve: {
          modalData: {
            accountPinLength: $scope.accountPinContent.pinLength
          }
        }
      })
      .result.then(
        function(result) {
          if (result.unlockedUntil != null) {
            $scope.accountPinContent.isEnabled = true;
            $scope.accountPinContent.isUnlocked = true;
            $scope.accountPinContent.unlockedUntil = result.unlockedUntil;
            $scope.startTimer(Math.floor(result.unlockedUntil));

            if (callback) {
              callback.apply();
            }
          }
        },
        function(error) {
          if (errorCallback) {
            errorCallback.apply();
          }
        }
      );
  };

  let interval;
  $scope.startTimer = function(secondsRemaining) {
    $scope.clearTimer();
    $scope.accountPinContent.timeRemaining = secondsRemaining;
    $scope.accountPinContent.timeRemainingMin = '--';
    $scope.accountPinContent.timeRemainingSec = '--';
    interval = $interval(function() {
      $scope.accountPinContent.timeRemaining = $scope.accountPinContent.timeRemaining - 1;
      $scope.accountPinContent.timeRemainingMin = Math.floor(
        $scope.accountPinContent.timeRemaining / 60
      );
      $scope.accountPinContent.timeRemainingSec = Math.floor(
        $scope.accountPinContent.timeRemaining - $scope.accountPinContent.timeRemainingMin * 60
      );

      if ($scope.accountPinContent.timeRemaining <= 0) {
        $scope.accountPinContent.isUnlocked = false;
        $scope.accountPinContent.unlockedUntil = null;
        $scope.clearTimer();
      }
    }, 1000);
  };

  $scope.clearTimer = function() {
    $interval.cancel(interval);
  };

  $scope.toggleAccountPinLockSetting = function() {
    if ($scope.accountPinContent.isUnlocked) {
      $scope.lockAccountPinSetting();
    } else {
      $scope.unlockAccountPinSetting();
    }
  };

  $scope.toggleAccountPinEnabledSetting = function() {
    // Email doesn't exist
    if (!$scope.accountContent.userInfo.data.IsEmailOnFile) {
      $scope.setEmailAddress(modalConstantsService.pinCreate.missingEmail);

      // Email not verified
    } else if (!$scope.accountContent.hasVerifiedEmail) {
      $scope.verifyEmailAddress(true, modalConstantsService.pinCreate.unverifiedEmail);

      // Toggle Account Pin
    } else {
      if ($scope.pinIsEnabledAndLocked()) {
        $scope.unlockAccountPinSetting($scope.toggleAccountPinEnabledSetting, retryPinUnlockLimit);
        return;
      }

      // Delete Account PIN
      if ($scope.accountPinContent.isEnabled) {
        accountsService.beginDeleteAccountPinSetting().then(
          function(result) {
            if (result) {
              $scope.accountPinContent.isEnabled = false;
              $scope.accountPinContent.isUnlocked = true;
              $scope.accountPinContent.unlockedUntil = null;
            }
          },
          function(error) {
            displayInfoModal('Error', $scope.processErrorMessage(error));
            $log.debug(error);
          }
        );

        // Create Account PIN
      } else {
        $uibModal
          .open({
            templateUrl: accountConstantsResources.templates.modal.pinCreate,
            controller: accountConstantsResources.controllers.modal.pinCreate,
            resolve: {
              modalData: {
                userEmail: $scope.accountContent.userInfo.data.UserEmail,
                accountPinLength: $scope.accountPinContent.pinLength
              }
            }
          })
          .result.then(
            function() {
              $scope.getAccountPinSetting();
            },
            function() {}
          )
          .finally(function() {
            $scope.getAccountPinSetting();
          });
      }
    }
  };

  $scope.getAccountRestrictions = function() {
    $scope.parentContent.accountRestrictions.isFeatureEnabled =
      $scope.accountContent.userInfo.data.IsAccountRestrictionsFeatureEnabled;
    accountsService.beginGetAccountRestrictions().then(
      function(result) {
        $scope.accountRestrictions = result;
      },
      function(error) {
        $log.debug('Error getting account restrictions settings');
      }
    );
  };

  $scope.toggleAccountRestrictionsSetting = function() {
    if ($scope.pinIsEnabledAndLocked()) {
      $scope.unlockAccountPinSetting($scope.toggleAccountRestrictionsSetting, retryPinUnlockLimit);
      return;
    }

    if ($scope.parentContent.accountRestrictions.isFeatureEnabled) {
      if (!$scope.accountRestrictions.IsEnabled) {
        $scope.contactSettings.MasterSetting = offText;
        $scope.onContactSettingsMasterSettingChange().then(
          accountsService
            .beginUpdateAccountRestrictions(!$scope.accountRestrictions.IsEnabled)
            .then(
              function() {
                $scope.accountRestrictions.IsEnabled = !$scope.accountRestrictions.IsEnabled;
                $scope.showSuccess();
              },
              function(error) {
                displayInfoModal(
                  modalConstantsService.default.error.title,
                  accountsService.beginProcessErrorMessage(error)
                );
              }
            )
        );
      } else {
        accountsService.beginUpdateAccountRestrictions(!$scope.accountRestrictions.IsEnabled).then(
          function() {
            $scope.accountRestrictions.IsEnabled = !$scope.accountRestrictions.IsEnabled;
            $scope.showSuccess();
          },
          function(error) {
            displayInfoModal(
              modalConstantsService.default.error.title,
              accountsService.beginProcessErrorMessage(error)
            );
          }
        );
      }
    }
  };

  // Toggle the 2SV Setting
  $scope.update2svSetting = function() {
    if (FormEvents) {
      if ($scope.twoStepContent.isEnabled) {
        // Disabling
        sendButtonClickEvent(accountConstantsResources.events.toggle2SVOff);
      } else {
        // Enabling
        sendButtonClickEvent(accountConstantsResources.events.toggle2SVOn);
      }
    }

    if (!$scope.accountContent.userInfo.data.IsAdmin) {
      if ($scope.pinIsEnabledAndLocked()) {
        $scope.unlockAccountPinSetting($scope.update2svSetting, retryPinUnlockLimit);
        return;
      }

      // Disabling 2SV
      if ($scope.twoStepContent.isEnabled) {
        // Disabling
        $scope.twoStepModalData = {
          action: modalConstantsService.default.submitButtonText,
          caption: modalConstantsService.twoStepVerification.disabling.title,
          doesPasswordExist: $scope.accountContent.userInfo.data.HasValidPasswordSet,
          isEnabling: false
        };

        const modalParams = {
          templateUrl: accountConstantsResources.templates.modal.twoStepSet,
          controller: accountConstantsResources.controllers.modal.twoStepSet,
          resolve: {
            modalData: $scope.twoStepModalData
          },
          scope: $scope
        };
        const modal = $uibModal.open(modalParams);

        modal.result.then(function() {
          get2SvSetting();
          $scope.refreshPage();
        });

        // Enable 2SV
      } else {
        // Email doesn't exist
        if (!$scope.accountContent.userInfo.data.IsEmailOnFile) {
          $scope.setEmailAddress(modalConstantsService.twoStepVerification.missingEmail);
        }

        // Email not verified
        else if (!$scope.accountContent.hasVerifiedEmail) {
          // check if verification has been updated outside of browser context
          accountsService.beginGetEmail().then(
            function(result) {
              if (result.verified) {
                // if email is verified proceed
                $scope.accountContent.hasVerifiedEmail = true;
                enable2Sv();
              } else {
                $scope.verifyEmailAddress(
                  true,
                  modalConstantsService.twoStepVerification.unverifiedEmail
                );
              }
            },
            function(error) {
              displayInfoModal(modalConstantsService.default.error.title, $scope.processErrorMessage(error));
            }
          );
        }

        // Turn on 2SV
        else {
          enable2Sv();
        }
      }
    }
  };

  function enable2Sv() {
    accountsService.enableEmailTwoStepVerification().then(() => {
      get2SvSetting();
      modalService.open({
        titleText: modalConstantsService.twoStepVerification.success.title,
        titleIcon: modalConstantsService.twoStepVerification.success.titleIcon,
        bodyText: modalConstantsService.twoStepVerification.success.body
      });
    }).catch(error => {
      displayInfoModal(modalConstantsService.default.error.title, error.message);
    });
  }

  function get2SvSetting() {
    accountsService.beginGet2svSettingV2().then(
      function(isEnabled) {
        $scope.twoStepContent.isEnabled = isEnabled;
      },
      function(error) {
        displayInfoModal(modalConstantsService.default.error.title, error.message);
      }
    );
  }

  $scope.setUpSocialDisconnect = function() {
    accountsService.beginGetSocialConnected().then(
      function(result) {
        if (result) {
          $scope.connectedAccounts.providers = result.providers;
          if (result.providers && result.providers[0]) {
            $scope.connectedAccounts.isConnectedAccountsBoxShown = true;
            result.providers.forEach(function(provider) {
              if (
                provider.provider.toLowerCase() ===
                accountConstantsResources.socialAuth.providers.facebook
              ) {
                $scope.hideConnectedAccountsDescription = true;
                $scope.gigyaUserInfo();
              }
            });
          } else {
            $scope.connectedAccounts.isConnectedAccountsBoxShown = false;
          }
        }
      },
      function(error) {
        displayInfoModal(
          modalConstantsService.default.error.title,
          accountsService.beginProcessErrorMessage(error)
        );
      }
    );
  };

  $scope.getXboxConnection = function() {
    $scope.xbox.isDisconnectXboxEnabled =
      $scope.accountContent.userInfo.data.IsDisconnectXboxEnabled;
    if ($scope.xbox.isDisconnectXboxEnabled) {
      accountsService.beginGetXboxConnection().then(function(result) {
        if (result && result.hasConnectedXboxAccount) {
          $scope.xbox.isDisconnectXboxBoxShown = true;
        } else {
          $scope.xbox.isDisconnectXboxBoxShown = false;
        }
      });
    }
  };

  $scope.setContactSettingsMasterSetting = function() {
    let result = customText;

    if ($scope.accountContent.userInfo.data.UserAbove13) {
      if (
        $scope.contactSettings.PrivateMessagePrivacy === friendsText &&
        $scope.contactSettings.AppChatPrivacy === friendsText &&
        $scope.contactSettings.GameChatPrivacy === allUsersText &&
        $scope.contactSettings.PhoneDiscoveryPrivacy === allUsersText
      ) {
        result = defaultText;
      } else if (
        $scope.contactSettings.PrivateMessagePrivacy === noOneText &&
        $scope.contactSettings.AppChatPrivacy === noOneText &&
        $scope.contactSettings.GameChatPrivacy === noOneText &&
        $scope.contactSettings.PhoneDiscoveryPrivacy === noOneText
      ) {
        result = offText;
      }
    } else if (
      $scope.contactSettings.PrivateMessagePrivacy === friendsText &&
      $scope.contactSettings.AppChatPrivacy === friendsText &&
      $scope.contactSettings.GameChatPrivacy === allUsersText
    ) {
      result = defaultText;
    } else if (
      $scope.contactSettings.PrivateMessagePrivacy === noOneText &&
      $scope.contactSettings.AppChatPrivacy === noOneText &&
      $scope.contactSettings.GameChatPrivacy === noOneText
    ) {
      result = offText;
    }

    $scope.contactSettings.MasterSetting = result;
  };

  function displayInfoModal(title, body) {
    return modalService.open({
      titleText: title,
      bodyText: body
    });
  }

  $scope.getCountryList = function() {
    accountsService.beginGetCountryList().then(
      function(result) {
        if (result.success) {
          $scope.allActiveCountryList = result.countryList;
          const defaultOption = {
            countryId: 0,
            countryName: commonConstantsService.label.country,
            localizedName: commonConstantsService.label.country,
            disabled: true
          };
          $scope.allActiveCountryList.unshift(defaultOption);
        } else {
          $log.debug('Failed to get list of countries.');
        }
      },
      function(error) {
        $log.debug(error);
      }
    );
  };

  $scope.getAccountSettingsPolicy = function() {
    if ($scope.accountInformationMetadata.isAccountSettingsPolicyEnabled) {
      let success = true;
      accountsService
        .beginGetAccountSettingsPolicy()
        .then(
          function(result) {
            $scope.accountSettingsPolicy = result;
          },
          function(error) {
            success = false;
          }
        )
        .finally(function() {
          $scope.incrementAccountSettingsPolicyCounter(success);
          $scope.initializeController();
        });
    } else {
      $scope.accountSettingsPolicy = accountConstantsResources.accountSettingsPolicyDefault;
      $scope.initializeController();
    }
  };

  $scope.incrementAccountSettingsPolicyCounter = function(success) {
    const counterValues = accountConstantsResources.counters;
    const result = success ? counterValues.success : counterValues.failure;
    eventTrackerService.fireEvent(counterValues.accountSettingPolicyPrefix + result);
  };

  $scope.initializeController = function() {
    if ($scope.accountSettingsPolicy.displayCountryList) {
      $scope.getCountryList();
    }
    $scope.getAccountSubscription();
    $scope.getAccountInfo();
  };

  $scope.getAccountInformationMetadataAndInitializeController = function() {
    accountsService
      .beginGetAccountInformationMetadata()
      .then(
        function(result) {
          $scope.accountInformationMetadata = result;
        },
        function(error) {
          // fallback to default values
        }
      )
      .finally(function() {
        $scope.getAccountSettingsPolicy();
      });
  };

  // go
  $scope.getAccountInformationMetadataAndInitializeController();

  function sendButtonClickEvent(buttonName) {
    if (EventStream) {
      EventStream.SendEvent(
        accountConstantsResources.events.formInteractionEventType,
        accountConstantsResources.events.settingsCtx,
        { btn: buttonName }
      );
    }
  }
}

accountSettingsModule.controller('accountsContentController', accountsContentController);

export default accountsContentController;
